import * as ReactDOM from 'react-dom';
import { useRef } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import { useIsClient } from '@utils/common';

// images
import Preloader from './images/preloader.gif';

// styles
import s from './ShafaLoader.sss';

// types
type ShafaLoaderProps = {
  in: boolean;
  timeout?: number;
  delay?: number;
  shadowOverlay?: boolean;
  fullScreen?: boolean;
  className?: string;
};

export const ShafaLoader: React.FC<ShafaLoaderProps> = ({
  shadowOverlay = false,
  fullScreen = true,
  delay = 200,
  className,
  ...props
}) => {
  const ref = useRef(null);
  const isClient = useIsClient();

  if (!isClient) {
    return null;
  }

  const component = (
    <CSSTransition
      appear={true}
      timeout={200 + delay}
      {...props}
      classNames={{
        appear: s.enter,
        appearDone: s.enterActive,
        enter: s.enter,
        enterActive: s.enterActive,
        enterDone: s.enterActive,
        exit: s.exitActive,
        exitActive: s.exitActive,
      }}
      nodeRef={ref}
    >
      <div
        ref={ref}
        className={
          classNames(
            s.root,
            { [s.fullScreen]: fullScreen },
            { [s.shadowOverlay]: shadowOverlay },
            className,
          )
        }
        style={{ transitionDelay: `${delay}ms` }}
      >
        <img
          className={s.image}
          src={Preloader}
          alt="preloader"
        />
      </div>
    </CSSTransition>
  );

  if (fullScreen) {
    return ReactDOM.createPortal(
      component,
      document.body,
    );
  }

  return component;
};
